var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbleRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_893_2592)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_893_2592",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 513,
    height: 512
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.319 0H0.319336V512H512.319V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_893_2592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.319 512C397.704 512 512.319 397.385 512.319 256C512.319 114.615 397.704 0 256.319 0C114.934 0 0.319336 114.615 0.319336 256C0.319336 397.385 114.934 512 256.319 512Z",
    fill: "url(#paint0_linear_893_2592)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.436 158.291C428.084 302.507 335.382 370.67 252.277 377.939C175.014 384.696 102.287 337.221 95.9067 264.279C90.6436 204.017 127.889 178.361 157.152 175.804C187.249 173.165 212.542 193.921 214.736 219.052C216.849 243.213 201.773 254.211 191.288 255.126C182.996 255.853 172.564 250.819 171.622 240.01C170.814 230.722 174.341 229.457 173.479 219.59C171.945 202.024 156.627 199.978 148.241 200.705C138.092 201.594 119.678 213.439 122.262 242.944C124.86 272.705 153.396 296.221 190.803 292.95C231.171 289.423 259.276 257.993 261.39 213.91C261.37 211.575 261.862 209.264 262.83 207.139L262.843 207.086C263.278 206.162 263.787 205.275 264.364 204.434C265.226 203.142 266.33 201.715 267.756 200.153C267.77 200.113 267.77 200.113 267.797 200.113C268.833 198.942 270.085 197.677 271.498 196.317C289.132 179.68 352.638 140.443 412.698 152.867C413.968 153.139 415.115 153.814 415.969 154.792C416.823 155.77 417.337 156.997 417.436 158.291Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_893_2592",
    x1: 512.013,
    y1: 86.519,
    x2: 17.5951,
    y2: 279.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_893_2592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbleRound);
export default __webpack_public_path__ + "static/media/Symble_Round.3d2ca91813b2753b504e10a6f617a995.svg";
export { ForwardRef as ReactComponent };